import { createContext, useCallback, useContext } from 'react'

import { validateContext } from 'shared/utils'

import { openKeys } from './reducer'

export const AccordionStateContext = createContext({})
export const AccordionDispatchContext = createContext(() => {})

export const useAccordionState = () => validateContext(useContext(AccordionStateContext), {
  contextName: 'AccordionStateContext',
  providerName: 'AccordionProvider'
})

const useAccordionDispatch = () => validateContext(useContext(AccordionDispatchContext), {
  contextName: 'AccordionDispatchContext',
  providerName: 'AccordionProvider'
})

export const useAccordion = () => {
  const state = useAccordionState()
  const dispatch = useAccordionDispatch()

  return {
    ...state,
    dispatch,
    openKeys: useCallback((keys) => dispatch(openKeys(keys)), [dispatch])
  }
}
